class StickyHeader extends HTMLElement {
  constructor() {
    super();

    window.addEventListener("resize", this.updateHeaderPosition);
  }

  connectedCallback() {
    this.header = document.querySelector(".section-header");
    this.headerBounds = {};
    this.headerSearch = this.header.querySelector('.header__search');

    this.updateHeaderPosition();

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
    this.createMutationObserver();
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  createMutationObserver() {
    const mutObserve = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const promotionBanner = this.querySelector('.yie-outer-element');
          observer.disconnect();
          if (promotionBanner) {
            this.promotionBannerBounds = promotionBanner.getBoundingClientRect().top;
            this.updateSearchPosition();
            break;
          }
        }
      }
    });

    mutObserve.observe(this, { childList: true, subtree: true });
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    this.updateHeaderPosition();
    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove("scrolled-past-header");
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  updateHeaderPosition() {
    this.header = document.querySelector(".section-header");
    document.documentElement.style.setProperty(
      "--header-position",
      `${this.header ? this.header.getBoundingClientRect().bottom : 0}px`
    );
  }

  updateSearchPosition() {
    if (this.headerSearch && this.headerBounds.height && this.promotionBannerBounds) {
      const topPosition = this.headerBounds.height + this.promotionBannerBounds - 6;
      document.documentElement.style.setProperty('--search-top-position', `${topPosition}px`);
    }
  }

  hide() {
    this.header.classList.add(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky"
    );
    this.closeMenuDisclosure();
  }

  reveal() {
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.classList.remove("shopify-section-header-hidden");
  }

  reset() {
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate"
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll("header-menu");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }
}

customElements.define("sticky-header", StickyHeader);
